import PubSub from 'pubsub-js';

const register = (actionType, callback = () => { }) => PubSub.subscribe(actionType, (msg, data) => callback(msg, data));

const unregister = (token) => PubSub.unsubscribe(token);

const dispatch = (actionType, value = null) => PubSub.publish(actionType, value);

export default {
    register,
    unregister,
    dispatch
};
